import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EvaSubnavModule } from '@shopping-angular-components/eva-subnav';
import { SubnavModuleComponent } from './eva-subnav.component';
import { MainTitleModule } from '../main-title/main-title.module';

@NgModule({
    declarations: [
        SubnavModuleComponent
    ],
    imports: [
        CommonModule,
        MainTitleModule,
        EvaSubnavModule
    ],
    exports: [
        SubnavModuleComponent
    ]
})
export class SubnavModuleModule {}
